import { useQueryClient } from 'react-query';

import { Config } from '@nw/shared/config';

const CommonDataDistrictURL = `${Config.COMMON_DATA_DISTRICT_BASE_URL}`;

const fetchDistrictsData = (signal, stateId) => {
  return fetch(CommonDataDistrictURL, {
    signal,
    method: 'POST',
    body: JSON.stringify({
      data: JSON.stringify(
        JSON.stringify({
          state_id: stateId
        })
      ),
      clientKeyDetailsId: 1
    }),
    headers: { 'content-type': 'application/json' }
  }).then((res) => res.json());
};

const stateSpecificDistrictsListQuery = (signal, stateId) => ({
  queryKey: ['districtsList', stateId],
  queryFn: async () => fetchDistrictsData(signal, stateId)
});

export const useQueryClientDistrictsHook = async (signal, stateId) => {
  const queryClient = useQueryClient();
  const query = stateSpecificDistrictsListQuery(signal, stateId);

  if (queryClient.getQueryData(query.queryKey)) {
    return queryClient.getQueryData(query.queryKey);
  }
  return await queryClient.fetchQuery(query.queryKey, query.queryFn, {
    cacheTime: Infinity
  });
};
